import {GoogleMap, useJsApiLoader, OverlayView} from "@react-google-maps/api";
import LocationPin from "assets/images/LocationPin";

type Props = {
  center: google.maps.LatLng | google.maps.LatLngLiteral;
  className?: string;
};

export default function Map(props: Props) {
  const {isLoaded} = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDvrSf2_Ymp_1Pa1DbRsfoL89C5EM_lczk",
  });

  if (!isLoaded) {
    return null;
  }

  return (
    <GoogleMap
      mapContainerClassName={props.className}
      center={props.center}
      zoom={16}
    >
      <OverlayView mapPaneName="markerLayer" position={props.center}>
        <div style={{transform: "translateX(-50%) translateY(-100%)"}}>
          <LocationPin />
        </div>
      </OverlayView>
    </GoogleMap>
  );
}
